<template>
  <div class="app-tariffs-wrapper">
    <slot name="txtBefore">
    </slot>
    <BookableDetailsWithActions
      v-for="tariffs in bookableTariffs_" :key="tariffs.tariffId"
      :details="createDetails(compileTariff(tariffs))"
      :actions="[ { type: 'details', text: 'Jetzt wechseln' }]"
      :info="createInfo(compileTariff(tariffs))"
      :content-theme="tariffs.tariffId"
      @click:details="showTariffModal(tariffs)"
    >
      <template v-for="slot in possibleChildSlotsFor('BookableTariff')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </BookableDetailsWithActions>
    <TariffModalWrapper
      v-if="show"
      ref="modalAction"
      @refresh="refreshQuery"
    >
      <template v-for="slot in possibleChildSlotsFor('ModalWrapper')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </TariffModalWrapper>
  </div>
</template>

<script>
import BookableDetailsWithActions from './CurrentTariff/DetailsWithActions.vue'
import slotProxy from '@/mixins/slotProxy'
import TariffModalWrapper from '@/components/process/generic/Tariff/generic/TariffModalWrapper.vue'
import { wrapQuery } from '@/helper/wrapGQLQuery'
import gql from 'graphql-tag'
import joinTariffExtra from '@/helper/joinTariffExtras'
import { price } from '@/mixins/price'
import extraData from '@/mixins/extraData'
import { durationUnit } from '@/mixins/durationUnit'
import { mapActions } from 'vuex'
import transaction from '@/mixins/transaction'

export default {
  name: 'TariffsWrapper',
  components: { TariffModalWrapper, BookableDetailsWithActions },
  mixins: [
    slotProxy(),
    extraData(),
    transaction('changeTariff')
  ],
  data () {
    return {
      show: false,
      tariffs: {
        bookedTariff: null,
        pendingTariff: null,
        bookableTariffs: null
      }
    }
  },
  computed: {
    bookableTariffs_ () {
      if (this.tariffs.bookableTariffs) {
        return this.tariffs.bookableTariffs.bookableTariffs
      }
      return null
    },
    bookedTariff_ () {
      if (this.tariffs.bookedTariff) {
        return this.tariffs.bookedTariff
      }
      return null
    }
  },
  methods: {
    ...mapActions('bookTariff', [
      'bookTariff'
    ]),
    compileTariff (tariff, isPending) {
      tariff = joinTariffExtra(tariff, this.extraData.tariffs)
      return tariff
    },
    createInfo (tariff) {
      return {
        name: tariff.name
      }
    },
    createDetails (tariff) {
      const flatTexts = []
      if (tariff.phoneFlat === 'all') {
        flatTexts.push(this.extraData.flatTexts.phone)
      }
      if (tariff.smsFlat === 'all') {
        flatTexts.push(this.extraData.flatTexts.sms)
      }
      let volumes = []
      if (tariff.tariffExtra !== undefined && tariff.tariffExtra.volumes instanceof Array) {
        volumes = tariff.tariffExtra.volumes
      }
      const priceDetail = {
        primary: price(tariff.basicFee),
        secondary: tariff.runtime?.amount === 0 ? null : '/' + tariff.runtime?.amount + ' ' + durationUnit(tariff.runtime?.unit.toUpperCase(), tariff.runtime?.amount)
      }
      return [...flatTexts, ...volumes, priceDetail]
    },
    refreshQuery () {
      this.$apollo.queries.tariffs.refetch()
    },
    showTariffModal (tariff) {
      this.show = true
      this.bookTariff({ tariffId: tariff.tariffId })
        .then((response) => {
          if (response.success === true) {
            const ctariff = this.compileTariff(tariff)
            this.$refs.modalAction.showTariffsModal(ctariff, response.contractUrl, this.bookedTariff_, response.notification)
          }
        })
    }
  },
  apollo: {
    tariffs: function () {
      return wrapQuery(
        gql`query changeTariff {
         tariffs {
           bookedTariff {
             tariffId
             name
             basicFee
             statusKey
             smsFlat
             phoneFlat
             renewContractDate
             possibleChangingDate
             terminationDate
             runtime {
               amount
               unit
             }
             volumes {
               amount
               formattedUnit
               type
               unit
             }
           }
           pendingTariff {
             tariffId
             name
             basicFee
             statusKey
             smsFlat
             phoneFlat
             changeTariffDate
             runtime {
               amount
               unit
             }
             volumes {
               amount
               formattedUnit
               type
               unit
             }
           }
           bookableTariffs {
             bookableTariffs {
              tariffId
              name
              tariffText
              smallIcon
              smsFlat
              phoneFlat
              footnote
              type
              colorCode
              basicFee
              contractPeriod
              formattedBasicFee
              icons{
                  text
                  icon
              }
              runtime{
                  amount
                  unit
                  formattedUnit
              }
              volumes {
               amount
               formattedUnit
               type
               unit
             }
              formattedDiscountedBasicFee
             }

           }
         }
        }`, this, 'tariffs')
    }
  }
}
</script>
